// The new site's pages (staging only until launch: src/lib/homeFlag.ts). Photohawk is two products, and every page
// belongs to one of them (or to both, on the home page):
//   "/"          the home page: what Photohawk is, then two doors, the Photohawk app and Studio
//   "/personal"  the Photohawk app (it was "Photohawk Personal"), the phone app for your own photos (coming soon: a
//                waitlist until the App Store listing exists). Its legal pages stay under /personal/*. "/app" is a
//                301 to it: /personal keeps its indexed URL, hreflang set and the app's legal links, so it stays the
//                canonical one.
//   "/studio"    Photohawk Studio, for photographers and event businesses: galleries, selling, Find your photos,
//                live upload, the Studio app and the Studio plans. "/events" (its URL before), "/business" (the
//                staging URL before that) and "/?for=business" are 301s to it.
//   "/download"  the Studio app's page: Mac and iPhone/iPad launch in November 2026 (Windows later). Until then
//                Studio is used in the web browser, and nothing on the site offers a download.

export const STUDIO_PATH = "/studio";
export const APP_PATH = "/personal";
export const DOWNLOAD_PATH = "/download";
/** The Studio page's URLs before it was named: both 301 to STUDIO_PATH where the new site is on. */
export const OLD_STUDIO_PATHS = ["/events", "/business"] as const;
/** The app page's short alias: a 301 to APP_PATH where the new site is on. */
export const APP_ALIAS_PATHS = ["/app"] as const;
/** The app page's waitlist anchor. */
export const APP_WAITLIST = `${APP_PATH}#waitlist`;
/** The Studio page's plans (Lite, Pro, Max) and its Studio app section. */
export const STUDIO_PRICING = `${STUDIO_PATH}#pricing`;
export const STUDIO_APP = `${STUDIO_PATH}#studio-app`;
/** Studio accounts: where a new one starts (free) and where it signs in. Personal signs in inside the app. */
export const REGISTER_PATH = "/register";
export const LOGIN_PATH = "/login";
/** Where participants find their event photos (a Studio feature, open to everyone). */
export const FIND_PATH = "/find-your-photos";

/**
 * Photohawk Personal in the stores. Empty until the listing is live: the site then shows "Coming soon to the App
 * Store" and the waitlist instead of a store badge. The owner fills these (the same URLs as
 * server/personal-app-links.json's appStoreUrl / playStoreUrl).
 */
export const PERSONAL_APP_STORE_URL = "";
export const PERSONAL_PLAY_STORE_URL = "";

/**
 * The Studio app's downloads, for /download. Empty until the app launches (Mac and iPhone/iPad in November 2026,
 * Windows later) and the owner gives the public links (the macOS build, the App Store listing, Windows once it
 * ships). While a link is empty, /download says "Launching November 2026" for Mac and iPhone/iPad and "Later" for
 * Windows, and its main action is Studio in the browser. Nothing links to a file that isn't public.
 */
export const STUDIO_DOWNLOADS: Record<"mac" | "ios" | "windows", string> = { mac: "", ios: "", windows: "" };
/** "Get notified when the app launches": an email to support (the Personal waitlist is Personal's own list). */
export const STUDIO_APP_NOTIFY = "mailto:support@photohawk.com?subject=Photohawk%20Studio%20app%3A%20tell%20me%20when%20it%20launches";

/** The URL's ?lang=, kept on internal links between the new pages ("" when there is none). */
export const keepLang = (search: string): string => {
  const lang = new URLSearchParams(search).get("lang");
  return lang ? `?lang=${encodeURIComponent(lang)}` : "";
};
